import { FileText, DollarSign, TrendingDown, Banknote } from "lucide-react";

const formatCurrency = (value) => {
  if (!value && value !== 0) return "-";
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
};

function Kpi({ label, value, Icon, tone, testid }) {
  const tones = {
    slate: "border-slate-200 bg-slate-50 text-slate-700",
    emerald: "border-emerald-200 bg-emerald-50 text-emerald-700",
    orange: "border-orange-200 bg-orange-50 text-orange-700",
    blue: "border-blue-200 bg-blue-50 text-blue-700",
  }[tone];
  return (
    <div className={`flex items-center gap-1.5 rounded-md border px-2 py-1 ${tones}`} data-testid={testid}>
      <Icon className="h-3.5 w-3.5 shrink-0 opacity-70" />
      <span className="text-[10px] uppercase tracking-wide opacity-70 whitespace-nowrap">{label}</span>
      <span className="text-xs font-bold whitespace-nowrap">{value}</span>
    </div>
  );
}

export default function TotaisCliente({ totais }) {
  const t = totais || {};
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="raio-x-cliente">
      <span className="mr-0.5 text-[10px] font-bold uppercase tracking-wide text-slate-500">Raio-X</span>
      <Kpi label="Contratos" value={t.totalContratos ?? 0} Icon={FileText} tone="slate" testid="rx-total-contratos" />
      <Kpi label="Parcelas" value={formatCurrency(t.totalParcelas)} Icon={DollarSign} tone="emerald" testid="rx-total-parcelas" />
      <Kpi label="Saldo Devedor" value={formatCurrency(t.totalSaldoDevedor)} Icon={TrendingDown} tone="orange" testid="rx-total-saldo" />
      <Kpi label="Liberado" value={formatCurrency(t.totalLiberado)} Icon={Banknote} tone="blue" testid="rx-total-liberado" />
    </div>
  );
}
